import { yup } from '@framework/validation';
import { fromPairs, isEmpty } from 'lodash';
import { WidgetDirectivesRepository } from './WidgetDirectivesRepository';

/**
 * Costruiamo dinamicamente lo schema di validazione per le direttive di
 * widget in base a quante registrazioni ci sono nel repository.
 */
export const WidgetDirectivesSchema = yup.lazy(() => {
  const directives = WidgetDirectivesRepository.getAll();
  return yup
    .object(
      fromPairs(
        directives.map(directive => [
          directive.key,
          directive.configSchema
            .nullable()
            .default(() => undefined)
            .transform(v => {
              const transformedValue =
                isEmpty(v) ||
                Object.values(v).every(value => value == null || value === '')
                  ? null
                  : v;
              return transformedValue;
            }),
        ]),
      ),
    )
    .noUnknown()
    .default(() => undefined)
    .transform(v => {
      return isEmpty(v) ? undefined : v;
    });
});
